import { Component, OnInit } from '@angular/core';
import { NbDialogRef, NbToastrService } from '@nebular/theme';
import { FileVm } from '../../../../shared/Models/fileVm';
import { DspaceService } from '../../services/dspace-service';
import { Dspace } from '../../models/dspace';
import * as momentHijri from 'moment-hijri';
import { Router } from '@angular/router';

@Component({
  selector: 'app-add-dspace',
  templateUrl: './add-dspace.component.html',
  styleUrls: ['./add-dspace.component.scss'],
})
export class AddDspaceComponent implements OnInit {
  model: Dspace = {} as Dspace;
  formData: FormData = new FormData();
  validPhoto = false;
  isEdit = false;
  uploadThumbnail = false;
  isLoading: boolean = false;

  constructor(
    private service: DspaceService,
    private diagRef: NbDialogRef<AddDspaceComponent>,
    private toast: NbToastrService,
    private route : Router
  ) {}

  ngOnInit() {
      this.route.events.subscribe(()=>{
      this.diagRef.close('false');
     });
    if (!this.isEdit) {
      this.uploadThumbnail = true;
    } else {
      this.validPhoto = true;
    }
  }

  save() {
    this.isLoading = true;
    if (!this.model.createdDate) {
      this.model.createdDate = momentHijri(new Date());
    }
    this.service.uploadFile(this.formData).subscribe((res) => {
      this.model.thumbnail = {} as FileVm;
      this.model.thumbnail.fileName = res.fileName;
      this.model.createdDate = new Date(this.model.createdDate).toISOString().split('T')[0];
      this.service.post(this.model).subscribe((res) => {
        this.isLoading = false;
        this.diagRef.close('true');
        this.toast.show('تم الإضافة بنجاح', '', { status: 'success', duration: 3000 });
      });
    });
  }

  getFormData(event) {
    this.formData = event;
    if (event) this.validPhoto = true;
  }

  close() {
    this.diagRef.close();
  }

  removePhoot() {
    this.uploadThumbnail = true;
    this.validPhoto = false;
  }

  updateDspace() {
    this.isLoading = true;
    let hasNewFile = false;
    this.formData.forEach((_) => {
      hasNewFile = true;
    });

    if (hasNewFile) {
      this.service.uploadFile(this.formData).subscribe((res) => {
        this.model.thumbnail.fileName = res.fileName;
        this.formData.forEach((file) => {
          this.model.thumbnail.originalFileName = file.valueOf()['name'];
        });

        this.update();
      });
    } else {
      this.update();
    }
  }

  update() {
    this.model.createdDate = new Date(this.model.createdDate).toISOString().split('T')[0];

    this.service.put(this.model.id, this.model).subscribe(
      (res) => {
        this.isLoading = false;
        this.diagRef.close('true');
        this.toast.show('تم التعديل بنجاح', '', { status: 'success', duration: 3000 });
      },
      (error) => {
        this.isLoading = false;
        this.toast.show('حدث خطأ أثناء التعديل ', '', { status: 'danger', duration: 3000 });
      }
    );
  }

  setDate(event) {
    this.model.createdDate = event;
  }
}
